import { 
    ImageProcessor,
} from "../../base/image_processors_utils.js";

export class ViTImageProcessor extends ImageProcessor { }
export class ViTFeatureExtractor extends ViTImageProcessor { }

